module.exports = __webpack_public_path__ + "static/img/16areaA_3.9a8af8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/16areaA_3.png
// module id = 808
// module chunks = 1